"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _icons = require("@material-ui/icons");
var _styles = _interopRequireDefault(require("./styles"));
var _index = _interopRequireDefault(require("../Drawer/index"));
var _Auth = require("../../contexts/Auth");
var _PdfReader = _interopRequireDefault(require("../../services/PdfReader"));
var _Trackings = _interopRequireDefault(require("../../services/Trackings"));
var _ReferencePopover = _interopRequireDefault(require("../ReferencePopover"));
var _HighlightList = require("../../contexts/HighlightList");
var _StylePopover = _interopRequireDefault(require("../StylePopover"));
var _Theme = require("../../contexts/Theme");
var _Copy = _interopRequireDefault(require("../../services/Copy"));
var _Bookmarks = require("../../contexts/Bookmarks");
var _Copy2 = require("../../contexts/Copy");
var _Bookmark = _interopRequireDefault(require("../../api/Bookmark"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function SideBar(_ref) {
  var {
    pdf
  } = _ref;
  var {
    auth
  } = (0, _Auth.useAuth)();
  var {
    focus,
    setFocus
  } = (0, _HighlightList.useHighlightList)();
  var trackService = (0, _Trackings.default)(auth);
  var classes = (0, _styles.default)();
  var [openDrawer, setOpenDrawer] = (0, _react.useState)(false);
  var [openReference, setOpenReference] = (0, _react.useState)(false);
  var [currentPage, setCurrentPage] = (0, _react.useState)();
  var [openStyle, setOpenStyle] = (0, _react.useState)(false);
  var [chapters, setChapters] = (0, _react.useState)([]);
  var {
    copyValue,
    setCopyValue
  } = (0, _Copy2.useCopy)();
  var styleRef = (0, _react.useRef)();
  var {
    theme
  } = (0, _Theme.useTheme)();
  var {
    isPageBookmarked,
    setIsPageBookmarked,
    bookmarks,
    setBookmarks
  } = (0, _react.useContext)(_Bookmarks.BookmarksContext);
  (0, _react.useEffect)(() => {
    if (focus) setOpenDrawer(true);
  }, [focus]);
  (0, _react.useEffect)(() => {
    var getInitialCopyValue = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* () {
        if (!pdf) return;
        var {
          applicationToken,
          sessionToken,
          userId,
          uuid
        } = auth;
        var initialCopyValue = yield _Copy.default.getCopyValue(applicationToken, sessionToken, userId, uuid, pdf);
        setCopyValue(parseInt(initialCopyValue));
      });
      return function getInitialCopyValue() {
        return _ref2.apply(this, arguments);
      };
    }();
    getInitialCopyValue();
  }, [auth, pdf, setCopyValue]);
  (0, _react.useEffect)(() => {
    if (!pdf) return;
    var onScroll = () => setCurrentPage(pdf.viewer.currentPageNumber);
    pdf.viewer.container.addEventListener('scroll', onScroll);
    return () => pdf.viewer.container.removeEventListener('scroll', onScroll);
  }, [pdf]);
  var selectTab = param => {
    return param;
  };
  var handleReferencePopover = () => {
    setOpenReference(true);
  };
  (0, _react.useEffect)(() => {
    if (!pdf) return;
    var onScroll = () => setCurrentPage(pdf.viewer.currentPageNumber);
    pdf.viewer.container.addEventListener('scroll', onScroll);
    return () => pdf.viewer.container.removeEventListener('scroll', onScroll);
  }, [pdf]);
  (0, _react.useEffect)(() => {
    if (!pdf) return;
    var res = bookmarks.some(bookmark => bookmark.page_reference === String(pdf.viewer.currentPageNumber));
    setIsPageBookmarked(Boolean(res));
  }, [currentPage, bookmarks, pdf, setIsPageBookmarked]);
  (0, _react.useEffect)(() => {
    var {
      applicationToken,
      sessionToken,
      uuid,
      userId
    } = auth;
    _Bookmark.default.getAll(applicationToken, sessionToken, uuid, userId).then(response => setBookmarks(response.data));
  }, [auth, setBookmarks]);
  function loadBookmarks() {
    var {
      applicationToken,
      sessionToken,
      uuid,
      userId
    } = auth;
    _Bookmark.default.getAll(applicationToken, sessionToken, uuid, userId).then(response => setBookmarks(response.data));
  }
  function onRemove() {
    return _onRemove.apply(this, arguments);
  }
  function _onRemove() {
    _onRemove = _asyncToGenerator(function* () {
      var bookmarkToRemove = bookmarks.find(bookmark => bookmark.page_reference === String(pdf.viewer.currentPageNumber));
      yield _Bookmark.default.remove(auth.applicationToken, auth.sessionToken, Number(bookmarkToRemove.id));
      loadBookmarks();
    });
    return _onRemove.apply(this, arguments);
  }
  function onCreate(_x) {
    return _onCreate.apply(this, arguments);
  }
  function _onCreate() {
    _onCreate = _asyncToGenerator(function* (payload) {
      var response = yield _Bookmark.default.create(auth.applicationToken, auth.sessionToken, payload);
      var {
        data
      } = response;
      trackService.trackBookmark({
        chapter: data.chapter_name,
        bookmark: data.id
      });
      loadBookmarks();
    });
    return _onCreate.apply(this, arguments);
  }
  function handleUserBookmark(_x2) {
    return _handleUserBookmark.apply(this, arguments);
  }
  function _handleUserBookmark() {
    _handleUserBookmark = _asyncToGenerator(function* (pdf) {
      var page = pdf.viewer.currentPageNumber;
      var pdfTitle = yield _PdfReader.default.getBookTitle(pdf);
      var chapterTitle = yield _PdfReader.default.getOutlineByPage(pdf, page);
      var chapterDescription = yield _PdfReader.default.getContentFromPage(pdf, page);
      var title = (chapterTitle === null || chapterTitle === void 0 ? void 0 : chapterTitle.title) || pdfTitle || auth.bookTitle;
      var description = chapterDescription.items[2].str.trim().substring(0, 50);
      var payload = {
        chapter_name: title,
        page_reference: String(page),
        summary: description,
        book_id: auth.uuid,
        user_id: auth.userId
      };
      if (isPageBookmarked) {
        onRemove();
      } else {
        onCreate(payload);
      }
    });
    return _handleUserBookmark.apply(this, arguments);
  }
  var handleDrawerActions = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(function* (evt, action) {
      switch (action) {
        case 'summary':
          setFocus();
          selectTab('tab-0');
          setOpenDrawer(true);
          trackService.trackAccessIndex();
          break;
        case 'toggleBookmark':
          handleUserBookmark(pdf);
          break;
        case 'references':
          handleReferencePopover();
          break;
        case 'formatting':
          setOpenStyle(true);
          break;
        default:
          console.log('handleDrawerActions called.');
      }
    });
    return function handleDrawerActions(_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)(() => {
    if (pdf) {
      pdf.props.pdfDocument.getOutline().then(chapterList => setChapters(chapterList));
    }
  }, [pdf]);
  return /*#__PURE__*/_react.default.createElement(_core.AppBar, {
    position: "relative",
    className: classes.appBar,
    style: {
      backgroundColor: theme.sidebar.backgroundColor
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Toolbar, {
    className: classes.toolbar
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    color: "primary",
    className: classes.backButton,
    style: {
      color: theme.sidebar.color
    },
    startIcon: /*#__PURE__*/_react.default.createElement(_icons.ArrowBackIos, null),
    onClick: () => window.history.back()
  }, "Voltar"), /*#__PURE__*/_react.default.createElement(_core.BottomNavigation, {
    showLabels: true,
    className: classes.toolbarNavigationContainer,
    style: {
      backgroundColor: theme.sidebar.backgroundColor
    },
    onChange: (event, newValue) => handleDrawerActions(event, newValue)
  }, /*#__PURE__*/_react.default.createElement(_core.BottomNavigationAction, {
    label: "Menu",
    icon: /*#__PURE__*/_react.default.createElement(_icons.FormatListBulleted, null),
    value: "summary",
    className: classes.toolbarNavigation,
    style: {
      color: theme.sidebar.color
    },
    disabled: !pdf
  }), /*#__PURE__*/_react.default.createElement(_core.BottomNavigationAction, {
    label: isPageBookmarked ? 'Página marcada' : 'Marcar página',
    icon: isPageBookmarked ? /*#__PURE__*/_react.default.createElement(_icons.Bookmark, null) : /*#__PURE__*/_react.default.createElement(_icons.BookmarkBorder, null),
    value: "toggleBookmark",
    className: classes.toolbarNavigation,
    style: {
      color: theme.sidebar.color
    },
    disabled: !pdf
  }), /*#__PURE__*/_react.default.createElement(_core.BottomNavigationAction, {
    label: "Estilo",
    value: "formatting",
    icon: /*#__PURE__*/_react.default.createElement(_icons.FormatSize, null),
    className: classes.toolbarNavigation,
    style: {
      color: theme.sidebar.color
    },
    disabled: !pdf,
    ref: styleRef
  }), /*#__PURE__*/_react.default.createElement(_core.BottomNavigationAction, {
    label: "Refer\xEAncia",
    value: "references",
    icon: /*#__PURE__*/_react.default.createElement(_icons.FormatQuote, null),
    className: classes.toolbarNavigation,
    style: {
      color: theme.sidebar.color
    },
    disabled: !pdf
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.logo
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: theme.logo,
    alt: "Saraiva Educa\xE7\xE3o"
  }))), /*#__PURE__*/_react.default.createElement(_index.default, {
    openDrawer: openDrawer,
    setOpenDrawer: setOpenDrawer,
    chapters: chapters,
    pdf: pdf
  }), /*#__PURE__*/_react.default.createElement(_ReferencePopover.default, {
    openReference: openReference,
    setOpenReference: setOpenReference,
    pdf: pdf,
    copyValue: copyValue
  }), /*#__PURE__*/_react.default.createElement(_StylePopover.default, {
    open: openStyle,
    setOpen: setOpenStyle,
    anchorEl: styleRef.current,
    anchorOrigin: {
      vertical: 'center',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'center',
      horizontal: 'left'
    }
  }));
}
SideBar.propTypes = {
  pdf: _propTypes.default.object
};
var _default = exports.default = SideBar;